import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './shared-resources/msal/auth.service';
import { CommonService } from './shared-resources/services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'portal';
  imageUrl: string = '';
  constructor(private authService: AuthService,
    private router: Router, private commonService: CommonService,
    private location: Location,
    private activatedRoute: ActivatedRoute) {
    this.imageUrl = environment.assetsUrl;

    window.addEventListener('popstate',
    () => {
      this.commonService.setPopState(true);
      this.commonService.setClickNonEmployeeEvent(false);
      if(this.commonService.getGotoCoreServiceFromPortal() 
      || this.commonService.getPortalFromCore()
      || this.commonService.getHomePageFlag()){
        location.replaceState('/portal');
        this.router.navigate(['/portal']); 
      }
      else if(location.path() === '/portal'){
        if(this.commonService.isAgentUser() || this.commonService.isOfficeManagerUser()){
          location.back();
        } 
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['xcelerate']) {
        let actionType = this.commonService.getXceleratActionType();
        this.commonService.setIsXcelerateRedirect(true, params['Action']);
        if (actionType && actionType !== params['Action']) {
          this.commonService.setIsXcelerateRedirect(true, params['Action']);
          if (params['Action'] === '1') {
            this.router.navigate(['/portal/subscriptions/authentisign']);
          } else if (params['Action'] === '3') {
            this.router.navigate(['/portal/subscriptions/docusign']);
          }
        }
      } else {
        setTimeout(() => {
          if (!this.commonService.getIsXcelerateRedirect()) {
            this.router.navigate(['/'])
          }
        }, 200);
      }
    });
  }

  ngOnInit() {
    this.authService.userSubject.subscribe((res: any) => {
      if (this.commonService.getIsXcelerateRedirect()) {
        this.commonService.setAgentNumber(res.onPremisesSamAccountName);
      }
    })
  }
}

